import d from "./_assocIndexOf.js";
function i(e) {
  var t = this.__data__, a = d(t, e);
  return a < 0 ? void 0 : t[a][1];
}
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_listCacheGet.js
// module id = 1486
// module chunks = 41